<!-- You can now use your library component in app.component.html -->
<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)">
  <a ngxSlickItem *ngFor="let banner of desktopSlider.banners" class="slide" style="outline: none; box-shadow: none;">
    <a style="outline: none; box-shadow: none" href="{{ banner.url }}">
      <img src="{{ banner.domain + banner.path }}" />
    </a>
  </a>
</ngx-slick-carousel>